import axios from '@/lib/axios';
import { UserInvitation, Workspace } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0500. ワークスペースユーザ招待
 * [POST] /workspaces/:identifier/user_invitations
 */
type Props = {
  identifier: string;
  email: string;
  admin: boolean;
  team_ids: number[];
  approver_team_ids: number[];
  financial_officer_team_ids: number[];
  backofficer_team_ids: number[];
};
const createUserInvitation = (props: Props): Promise<UserInvitation> => {
  return axios.post(`/api/workspaces/${props.identifier}/user_invitations`, props);
};

export const useCreateUserInvitation = () => {
  return useMutation({
    mutationFn: createUserInvitation,
  });
};
